export default __webpack_public_path__ + "static/media/Wole.59636e4f.png";